import { NgModule } from '@angular/core';
import { ElementHeightDirective } from '@df/dom/element-height/element-height.directive';
import { providers } from './df-dom.providers';

@NgModule({
    imports: [ElementHeightDirective],
    exports: [ElementHeightDirective],
    providers: providers
})
export class DfDomModule {}
